import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import type { Option } from '@ds/components/InputSelect'

import { useMetadata } from '../../../composables/useMetadata'
import { VALUE_ALL } from '../Filters.constants'

import translations from './useOptions.translations'

export function useOptions() {
  const i18n = useI18n()
  const optionAll = { label: i18n(translations.all), value: VALUE_ALL }
  const { metadata } = useMetadata()

  const categoriesOption = computed<Option[]>(() => [
    optionAll,
    ...metadata.value.categoryFilterOptions,
  ])

  const gradeOptions = computed<Option[]>(() => [
    optionAll,
    ...metadata.value.gradeFilterOptions.map(({ label, value }) => ({
      label,
      value: value.toString(),
    })),
  ])

  const currencyFilterOptions = computed<Option[]>(() => [
    optionAll,
    ...metadata.value.currencyFilterOptions,
  ])

  const competitionOptions = computed<Option[]>(() => [
    optionAll,
    ...metadata.value.competitionFilterOptions,
  ])

  return {
    categoriesOption,
    gradeOptions,
    currencyFilterOptions,
    competitionOptions,
  }
}
